import styled from '../theme/styled-components';

const maxWidth = '1170px'; // TODO: Variable in theme?

export const Container = styled.div`
  margin: 0 auto;
  padding-left: ${props => props.theme.spacings.medium};
  padding-right: ${props => props.theme.spacings.medium};
  max-width: calc(${maxWidth} + ${props => props.theme.spacings.medium} * 2);

  ${media => media.theme.media.greaterThan('medium')`
    padding-left: ${props => props.theme.spacings.large};
    padding-right: ${props => props.theme.spacings.large};
  `}
`;
